import { render } from "./ImportCar.vue?vue&type=template&id=38b15eaa&scoped=true"
import script from "./ImportCar.vue?vue&type=script&lang=js"
export * from "./ImportCar.vue?vue&type=script&lang=js"

import "./ImportCar.vue?vue&type=style&index=0&id=38b15eaa&lang=sass&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b15eaa"]])

export default __exports__